import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";
interface IFilters {
    Field: string;
    ComparisonType: string;
    Value: string | boolean;
}
export const fetchTasksList = createAsyncThunk(
    'contract/fetchTasksList',
    async ({ contractID, sortArray, filters }: {
        contractID: string[],
        sortArray: string[] | [],
        filters: IFilters[] | [],
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "Limit": 10000000000000,
                "Offset": 0,
                ...(contractID.length > 0 && { "ContractIDs": contractID }),
                "SortableColumns": sortArray,
                "Filters": filters
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getTasks', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { tasks: data.Tasks, taskCount: data.TaskCount, fetchTime: parseToTimestamp(new Date()), contractID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);